import React from 'react';
import { AnimatedSection } from '../shared/AnimatedSection';
import { GlowCard } from '../shared/GlowCard';
export function ComoFunciona() {
  const steps = [{
    title: 'Selecciona tu signo',
    description: 'Elige la entidad que representa tu arquetipo.'
  }, {
    title: 'Entra a tu reino',
    description: 'Cada signo tiene su propia atmósfera, energía y lenguaje visual.'
  }, {
    title: 'Desbloquea tu experiencia',
    description: 'Comienza con el Núcleo del Arquetipo por $9.99 y agrega los archivos adicionales que quieras explorar.'
  }];
  return <section className="py-20 px-6 bg-cosmic-black" data-id="element-11">
      <div className="container mx-auto max-w-5xl" data-id="element-12">
        <AnimatedSection data-id="element-13">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-white mb-16" data-id="element-14">
            Cómo Funciona
          </h2>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-15">
          {steps.map((step, index) => <AnimatedSection key={index} delay={0.2 + index * 0.2} data-id="element-16">
              <GlowCard className="text-center h-full" data-id="element-17">
                <div className="w-16 h-16 rounded-full border-2 border-gold-primary flex items-center justify-center mx-auto mb-6" style={{
              boxShadow: '0 0 20px rgba(201, 168, 76, 0.3)'
            }} data-id="element-18">
                  <span className="text-2xl font-serif font-bold text-gold-light" data-id="element-19">
                    {index + 1}
                  </span>
                </div>
                <h3 className="text-xl font-serif font-semibold text-white mb-4" data-id="element-20">
                  {step.title}
                </h3>
                <p className="text-gray-300 leading-relaxed" data-id="element-21">
                  {step.description}
                </p>
              </GlowCard>
            </AnimatedSection>)}
        </div>
      </div>
    </section>;
}